import React, { useState, useEffect } from "react";
import {
  FaTimes,
  FaCreditCard,
  FaChevronRight,
  FaPlusSquare,
} from "react-icons/fa";

const TopBanner = () => {
  const [isVisible, setIsVisible] = useState(true);

  const bannerLinks = [
    {
      name: "Contractors Portal",
      link: "https://netapp.beninelectric.com",
    },
    {
      name: "Band 'A' Rapid Response",
      link: "/band-a-customers-emergency-response-contacts/",
    },
    {
      name: "Order a Meter",
      link: "https://imaap.beninelectric.com",
    },
    {
      name: "Quick Complaints",
      link: "https://crm.beninelectric.com/complaints",
    },
    {
      name: "Track Complaints",
      link: "https://crm.beninelectric.com/",
    },
    {
      name: "Feeder Information",
      link: "/customer-feeder-info",
    },
    {
      name: "Meter Refund",
      link: "/map-meter-refund",
    },
  ];

  useEffect(() => {
    const saved = sessionStorage.getItem("bannerVisible");
    if (saved === "false") {
      setIsVisible(true);
    }
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    sessionStorage.setItem("bannerVisible", "false");
  };

  if (!isVisible) return null;

 

  return (
    <div className="bg-gradient-to-r from-[#064e3b] to-[#16a34a] text-white shadow-lg w-full">
      <div className="w-full px-4 py-3 md:py-2 flex flex-col md:flex-row md:items-center justify-between gap-4">

        {/* LINKS */}
        <div className="flex-1">

          {/* Mobile: 2 Columns | Desktop: Horizontal */}
          <div className="grid grid-cols-2 gap-x-4 gap-y-2 md:hidden">
            {bannerLinks.map((item, index) => (
              <a
                key={index}
                href={item.link}
                className="flex items-center gap-2 text-[11px] font-bold hover:text-yellow-300 transition-colors"
              >
                <FaPlusSquare className="text-yellow-400 text-[10px] flex-shrink-0" />
                <span className="leading-tight">{item.name}</span>
              </a>
            ))}
          </div>

          {/* Desktop */}
          <div className="hidden md:flex items-center gap-6 whitespace-nowrap">
            {bannerLinks.map((item, index) => (
              <React.Fragment key={index}>
                <a
                  href={item.link}
                  className="text-sm font-bold tracking-tight hover:text-yellow-300 transition-colors"
                >
                  {item.name}
                </a>

                {index < bannerLinks.length - 1 && (
                  <span className="w-1.5 h-1.5 bg-yellow-400 rounded-full flex-shrink-0"></span>
                )}
              </React.Fragment>
            ))}
          </div>

        </div>

        {/* RIGHT SECTION */}
        <div className="flex items-center justify-between md:justify-end gap-3 flex-shrink-0">

          <a href="/e-payment-channels">
            <button className="flex items-center gap-2 bg-yellow-400 hover:bg-yellow-500 text-black font-black px-4 py-2 rounded-lg text-[10px] md:text-xs uppercase tracking-wider transition-all shadow-md active:scale-95">
              <FaCreditCard />
              <span>E-Payments</span>
              <FaChevronRight className="text-[8px]" />
            </button>
          </a>

          <button
            onClick={handleClose}
            className="p-1.5 hover:bg-white/20 rounded-full transition text-lg"
          >
            <FaTimes />
          </button>

        </div>
      </div>
    </div>
  );
};

export default TopBanner;